define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/constants",
	"csi/html",
	"csi/view/ToolbarFilter",
	"./ToolbarFilterMixin",

	"./Preferences"		// ensure that constants are populated
], function(declare, lang, _, constants, html, ToolbarFilter, ToolbarFilterMixin) {

	return declare([ToolbarFilter, ToolbarFilterMixin], {

		postCreate: function() {
			// summary: register events with table view
			var view = this.getView();

			this.inherited(arguments);

			view.watch("filterPosition", lang.hitch(this, this._onWatchPosition));
			this._onWatchPosition(null, null, view.get("filterPosition"));
		},

		_onWatchPosition: function(/*String*/name, /*Any*/oldValue, /*Any*/newValue) {
			// summary: change visibility of toolbar nodes based on position
			var bToolbar = (newValue == constants.FILTER_POSITION_TOOLBAR);
			var bColumn = (newValue == constants.FILTER_POSITION_COLUMN);

			if (oldValue == constants.FILTER_POSITION_COLUMN) {
				this._cleanupFilters();
			}

			html.setVisible(this._filterNode, bToolbar);
			html.setVisible(this._resetNode, bColumn);
			html.setVisible(this.filterContainer, bToolbar);
		},

	});
});